import { isNil } from 'lodash';
import React, { useCallback } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import { isAllocatorOpenState, openPrivateAllocatorPortfolio } from 'venn-state';
import { GetColor } from 'venn-ui-kit';
import { withSuspense } from 'venn-utils';
import { Constants } from '../Layout';
import { StudioAllocatorWindow } from './components';
import { PrivatesAllocatorPanel } from './PrivatesAllocatorPanel';
import { useUnsavedPrivatesAllocatorChangesModal } from './useUnsavedPrivatesAllocatorChangesModal';
import { ConfirmUnsavedChangesModal } from '../../unsaved-changes/ConfirmUnsavedChangesModal';
import { StudioAllocatorSubject } from './StudioAllocatorSubject';
import { StudioAllocationPanelShimmerBlock } from './StudioAllocationPanelShimmerBlock';
import { ResizableAllocationPanelWrapper } from './ResizableAllocationPanelWrapper';

const StudioPrivatesAllocationPanel = React.memo(() => {
  const [openPortfolio, setOpenPortfolio] = useRecoilState(openPrivateAllocatorPortfolio);
  const setIsAllocatorOpen = useSetRecoilState(isAllocatorOpenState);

  const onClosePanel = useCallback(() => {
    setOpenPortfolio(undefined);
    setIsAllocatorOpen(false);
  }, [setIsAllocatorOpen, setOpenPortfolio]);

  const {
    isUnsavedChangesModalOpen,
    closePanelOrTriggerUnsavedChangesModal,
    discardChangesAndClosePanel,
    closeUnsavedChangesModal,
  } = useUnsavedPrivatesAllocatorChangesModal(onClosePanel);

  const allocatorWidth = 1 + Constants.ALLOCATION_PANEL_MAIN_WIDTH;

  return (
    <ResizableAllocationPanelWrapper defaultWidth={allocatorWidth}>
      <StudioAllocatorWindow>
        <StudioAllocatorSubject isPrivate onClose={closePanelOrTriggerUnsavedChangesModal} disabled={false} />
        {!isNil(openPortfolio) && (
          <AllocationPanelWrapper data-testid="studio-privates-allocator-wrapper">
            <PrivatesAllocatorPanel />
          </AllocationPanelWrapper>
        )}
        {isUnsavedChangesModalOpen && (
          <ConfirmUnsavedChangesModal
            onProceed={discardChangesAndClosePanel}
            onReject={closeUnsavedChangesModal}
            ignoreUnsavedViewChanges
          />
        )}
      </StudioAllocatorWindow>
    </ResizableAllocationPanelWrapper>
  );
});
StudioPrivatesAllocationPanel.displayName = 'StudioPrivatesAllocationPanel';

export default withSuspense(<StudioAllocationPanelShimmerBlock isPrivate />, StudioPrivatesAllocationPanel);

const AllocationPanelWrapper = styled.div`
  grid-area: allocator-panel;
  background-color: ${GetColor.White};
  overflow-x: hidden;
`;
